import React from "react";
import PropTypes from "prop-types";
import Plx from "react-plx";

import css from "./FeatureImageQuoteContent.module.scss";
import AnimateOpacity from "components/ParallaxAnimation/AnimateOpacity";
import QuoteBlock from "components/QuoteBlock";

const plxData = element => [
    {
        start: element || "self",
        startOffset: "40vh",
        duration: "40vh",
        properties: [
            {
                startValue: 250,
                endValue: 0,
                property: "translateY"
            }
        ]
    }
];
class FeatureImageQuoteContent extends React.Component{
    static propTypes = {
        quote: PropTypes.object.isRequired
    };  

    componentDidMount(){
        this.forceUpdate()
    }
    
    render(){   
        return (
            <div className={css.featureImageQuoteContent} ref={ele => this.element = ele}>
                <AnimateOpacity
                    start="self"
                    startOffset="50vh"
                    duration="40vh"
                    className={css.darkFilter}
                >
                    <div className={css.quoteWrapper}>
                        <Plx parallaxData={plxData(this.element)}>
                            {this.props.quote && <QuoteBlock {...this.props.quote} />}
                        </Plx>
                    </div>
                </AnimateOpacity>
            </div>
        );
    }
}
export default FeatureImageQuoteContent;



// WEBPACK FOOTER //
// ./src/components/FeatureImageQuoteContent/FeatureImageQuoteContent.jsx